import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './IntakeForm.css';
import { LanguageContext } from '../App';
import { useAuth } from '../context/AuthContext';
import { getPostAuthRedirect } from '../utils/guestIntake';
import { translations } from '../utils/translations';

function Login() {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.en;
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await login(email, password);
      navigate(getPostAuthRedirect('/dashboard'), { replace: true });
    } catch (loginError) {
      setError(loginError.message || t.login.errors.unableToSignIn);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="form-section">
          <button className="back-button" onClick={() => navigate('/')}>
            {t.login.back}
          </button>
          <h2>{t.login.title}</h2>
          <p className="form-intro">{t.login.intro}</p>

          <form onSubmit={handleSubmit} className="intake-form">
            <div className="form-group">
              <label htmlFor="login-email">{t.login.email}</label>
              <input
                id="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.login.emailPlaceholder}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="login-password">{t.login.password}</label>
              <input
                id="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t.login.passwordPlaceholder}
                required
              />
            </div>

            {error && <div className="submit-message error-message-box">{error}</div>}

            <button type="submit" className="btn btn-primary btn-large" disabled={isSubmitting}>
              {isSubmitting ? t.login.submitLoading : t.login.submitIdle}
            </button>

            <button
              type="button"
              className="btn btn-secondary btn-large"
              onClick={() => navigate('/register')}
            >
              {t.login.createAccount}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
